import { Dispatch } from 'react';

import { ActiveFilter } from 'proto/Search/ActiveFilter';

import { SearchFormAction, SearchFormReducerAction } from './reducer/types';
import { SearchFormActions } from './types';

export const buildActionMap = (
    dispatch: Dispatch<SearchFormReducerAction>
): SearchFormActions => ({
    updateActiveFilterList(newList: ActiveFilter[]) {
        dispatch({
            type: SearchFormAction.UpdateActiveFilterList,
            payload: newList,
        });
    },
    removeActiveFilter(filterId: string) {
        dispatch({
            type: SearchFormAction.RemoveActiveFilter,
            payload: filterId,
        });
    },
    removeAllActiveFilter() {
        dispatch({ type: SearchFormAction.RemoveAllActiveFilter });
    },
});
